import * as React from "react";
import { ConnectedLayout } from "./Layout";

export const App = () => <ConnectedLayout />;
